import React, { useContext } from 'react';

import { NavContext } from "../../../contexts";
import { ComuniContext } from '../ComuniContext';

import CloseIcon from '@mui/icons-material/Close';

import { Autocomplete, Button, Dialog, DialogContent, DialogTitle, IconButton, TextField } from '@mui/material';
import { Field, Formik } from 'formik';

export const EditDialog = ({
    open,
    setOpen,
    disabled,
    onActionClick,
    ...props }) => {

    const {
        getRouteTo,
        navigateTo,
    } = useContext(NavContext);

    const {
        state,
    } = useContext(ComuniContext);

    const {
        editProvinceOptions,
        comuni,
        selectedComuni
    } = state;

    const updateClickHandler = async (data) => {
        if (onActionClick)
            onActionClick("Update", data);
    }

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Dialog open={open} onClose={handleClose} fullWidth>
                <IconButton
                    aria-label="close"
                    size="small"
                    sx={{
                        position: "absolute",
                        top: 4,
                        right: 4,
                    }}
                    onClick={() => setOpen(false)}>
                    <CloseIcon />
                </IconButton>
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
                    SELEZIONE LA NUOVA PROVINCIA
                </DialogTitle>
                <DialogContent>
                    <Formik
                        initialValues={{ provinciaId: null }}
                        onSubmit={null}>
                        {({
                            values,
                            handleSubmit,
                            setFieldValue,
                            errors,
                            touched,
                            setTouched,
                        }) => {
                            return <form onSubmit={handleSubmit}>
                                <Field
                                    name="provinciaId"
                                    component={Autocomplete}
                                    options={editProvinceOptions}
                                    onChange={(e, value) => {
                                        setFieldValue('provinciaId', value?.provinciaId)
                                    }}
                                    value={editProvinceOptions.find(option => option.provinciaId == values.provinciaId) ?? null}
                                    renderInput={(params) => <TextField {...params} label="Scegli..." />}
                                    fullWidth
                                    sx={{ paddingTop: 1 }}
                                />
                                <div style={{ display: "flex", justifyItems: "end", width: "100%", paddingTop: 8 }}>
                                    <Button
                                        onClick={() => {
                                            var data = comuni.result.filter(x => selectedComuni.includes(x.id));
                                            data.forEach(x => x.provinciaId = values.provinciaId);
                                            updateClickHandler(data);
                                        }}
                                        variant="contained"
                                        disableElevation>
                                        Aggiorna
                                    </Button>
                                </div>
                            </form>
                        }}
                    </Formik>
                </DialogContent>
            </Dialog>
        </>
    );
}